import { BRAND_LIST } from 'typings'

export const isUniqlo = (brand: BRAND_LIST) => brand === BRAND_LIST.UQ
export const isGu = (brand: BRAND_LIST) => brand === BRAND_LIST.GU
export const isPlst = (brand: BRAND_LIST) => brand === BRAND_LIST.PL
